import { render, staticRenderFns } from "./BrandPerformance.vue?vue&type=template&id=74cf6112&"
import script from "./BrandPerformance.vue?vue&type=script&lang=js&"
export * from "./BrandPerformance.vue?vue&type=script&lang=js&"
import style0 from "./BrandPerformance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports